"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M6 4.01C3.58 5.84 2 8.73 2 12c0 1.46.32 2.85.89 4.11L6 14.31zm5 7.41V2.05c-1.06.11-2.07.38-3 .79v10.32zm1 1.73-8.11 4.68c.61.84 1.34 1.59 2.18 2.2L15 14.89zm1-5.19v3.46l8.11 4.68c.42-.93.7-1.93.82-2.98zM8.07 21.2c1.21.51 2.53.8 3.93.8 3.34 0 6.29-1.65 8.11-4.16L17 16.04zm13.85-10.39c-.55-4.63-4.26-8.3-8.92-8.76v3.6z"
}), 'SportsVolleyballRounded');